export default "__VITE_ASSET__CGY45Id0__";